const header = {
  main: 'Início',
  simulate: 'Simular empréstimo',
  benefits: {
    label: 'Benefícios Creditas',
    at_work: 'Consignado',
    salary: 'Antecipação de salário',
  },
  support: 'Ajuda',
  logout: 'Sair',
  download_app: 'Mais praticidade? Baixe nosso app:',
  redirected_lead: 'Não é possível voltar para o formulário.',
};

export default header;
